// Stable scene-to-image mapping — never rely on upload order.
// Subtitle segments are pre-translated for en/nl/de/fr/es; only languages
// enabled in LanguageContext (en/nl today) are user-selectable.
export const SCENES = [
  {
    id: "the-greeting",
    dur: 10.06,
    kb: "in",
    origin: "50% 45%",
    focusD: "50% 50%",
    focusM: "45% 50%",
    subs: {
      en: [
        "Welcome, traveler, to the Grand Hall of the Academy of Practical Wisdom.",
        "I am Hipparchia.",
        "Allow me to introduce those who will accompany you on your journey.",
      ],
      nl: [
        "Welkom, reiziger, in de Grote Hal van de Academy of Practical Wisdom.",
        "Ik ben Hipparchia.",
        "Sta mij toe degenen voor te stellen die je tijdens jouw reis zullen begeleiden.",
      ],
      de: [
        "Willkommen, Reisender, in der Großen Halle der Academy of Practical Wisdom.",
        "Ich bin Hipparchia.",
        "Erlaube mir, dir diejenigen vorzustellen, die dich auf deiner Reise begleiten werden.",
      ],
      fr: [
        "Bienvenue, voyageur, dans le Grand Hall de l'Academy of Practical Wisdom.",
        "Je suis Hipparchia.",
        "Permets-moi de te présenter ceux qui t'accompagneront tout au long de ton voyage.",
      ],
      es: [
        "Bienvenido, viajero, al Gran Salón de la Academy of Practical Wisdom.",
        "Soy Hipparchia.",
        "Permíteme presentarte a quienes te acompañarán en tu viaje.",
      ],
    },
  },
  {
    id: "marcus-aurelius",
    dur: 9.14,
    kb: "in",
    origin: "55% 35%",
    focusD: "50% 40%",
    focusM: "50% 45%",
    subs: {
      en: [
        "Marcus Aurelius, philosopher and emperor.",
        "He ruled an empire, yet understood that the first realm we must learn to govern is ourselves.",
      ],
      nl: [
        "Marcus Aurelius, filosoof en keizer.",
        "Hij bestuurde een rijk, maar begreep dat het eerste rijk dat wij moeten leren beheersen onszelf is.",
      ],
      de: [
        "Marcus Aurelius, Philosoph und Kaiser.",
        "Er regierte ein Reich, doch verstand, dass das erste Reich, das wir beherrschen lernen müssen, wir selbst sind.",
      ],
      fr: [
        "Marc Aurèle, philosophe et empereur.",
        "Il gouvernait un empire, mais comprenait que le premier royaume à maîtriser est nous-mêmes.",
      ],
      es: [
        "Marco Aurelio, filósofo y emperador.",
        "Gobernó un imperio, pero comprendió que el primer reino que debemos aprender a gobernar somos nosotros mismos.",
      ],
    },
  },
  {
    id: "epictetus",
    dur: 9.67,
    kb: "drift",
    origin: "50% 40%",
    focusD: "55% 40%",
    focusM: "50% 45%",
    subs: {
      en: [
        "Epictetus was born into slavery, yet became one of the freest of men.",
        "He teaches us to distinguish what is within our control from what is not.",
      ],
      nl: [
        "Epictetus werd geboren in slavernij, maar werd een van de vrijste mensen.",
        "Hij leert ons onderscheid te maken tussen wat binnen onze macht ligt en wat niet.",
      ],
      de: [
        "Epiktet wurde in die Sklaverei geboren und wurde doch einer der freiesten Menschen.",
        "Er lehrt uns zu unterscheiden, was in unserer Macht liegt und was nicht.",
      ],
      fr: [
        "Épictète est né esclave, et devint pourtant l'un des hommes les plus libres.",
        "Il nous apprend à distinguer ce qui dépend de nous de ce qui n'en dépend pas.",
      ],
      es: [
        "Epicteto nació en la esclavitud y, sin embargo, llegó a ser uno de los hombres más libres.",
        "Nos enseña a distinguir lo que está en nuestro poder de lo que no lo está.",
      ],
    },
  },
  {
    id: "seneca",
    dur: 9.17,
    kb: "out",
    origin: "50% 45%",
    focusD: "55% 40%",
    focusM: "50% 45%",
    subs: {
      en: [
        "Seneca, statesman, writer and philosopher.",
        "Through fortune, exile and adversity, he learned to transform experience into practical wisdom.",
      ],
      nl: [
        "Seneca, staatsman, schrijver en filosoof.",
        "Door voorspoed, ballingschap en tegenslag leerde hij ervaring om te vormen tot praktische wijsheid.",
      ],
      de: [
        "Seneca, Staatsmann, Schriftsteller und Philosoph.",
        "Durch Glück, Verbannung und Widrigkeiten lernte er, Erfahrung in praktische Weisheit zu verwandeln.",
      ],
      fr: [
        "Sénèque, homme d'État, écrivain et philosophe.",
        "À travers la fortune, l'exil et l'adversité, il apprit à transformer l'expérience en sagesse pratique.",
      ],
      es: [
        "Séneca, estadista, escritor y filósofo.",
        "A través de la fortuna, el exilio y la adversidad, aprendió a transformar la experiencia en sabiduría práctica.",
      ],
    },
  },
  {
    id: "four-mentors",
    dur: 8.09,
    kb: "soft",
    origin: "50% 45%",
    focusD: "50% 50%",
    focusM: "50% 50%",
    subs: {
      en: [
        "Four voices, united by one purpose:",
        "to help you cultivate wisdom, courage, justice and temperance,",
        "and to put philosophy into practice.",
      ],
      nl: [
        "Vier stemmen, verenigd door één doel:",
        "jou helpen wijsheid, moed, rechtvaardigheid en gematigdheid te ontwikkelen,",
        "en filosofie in praktijk te brengen.",
      ],
      de: [
        "Vier Stimmen, vereint durch ein Ziel:",
        "dir zu helfen, Weisheit, Mut, Gerechtigkeit und Mäßigung zu entwickeln,",
        "und Philosophie in die Praxis umzusetzen.",
      ],
      fr: [
        "Quatre voix, unies par un même but :",
        "t'aider à cultiver la sagesse, le courage, la justice et la tempérance,",
        "et à mettre la philosophie en pratique.",
      ],
      es: [
        "Cuatro voces, unidas por un mismo propósito:",
        "ayudarte a cultivar la sabiduría, el valor, la justicia y la templanza,",
        "y a llevar la filosofía a la práctica.",
      ],
    },
  },
  {
    id: "enter-the-academy",
    dur: 7.34,
    kb: "in",
    origin: "50% 55%",
    focusD: "50% 50%",
    focusM: "50% 50%",
    subs: {
      en: [
        "The doors of the Academy are open.",
        "Step inside, traveler.",
        "Your journey towards practical wisdom and inner freedom begins.",
      ],
      nl: [
        "De deuren van de Academy staan open.",
        "Stap naar binnen, reiziger.",
        "Jouw reis naar praktische wijsheid en innerlijke vrijheid begint.",
      ],
      de: [
        "Die Türen der Academy stehen offen.",
        "Tritt ein, Reisender.",
        "Deine Reise zu praktischer Weisheit und innerer Freiheit beginnt.",
      ],
      fr: [
        "Les portes de l'Academy sont ouvertes.",
        "Entre, voyageur.",
        "Ton voyage vers la sagesse pratique et la liberté intérieure commence.",
      ],
      es: [
        "Las puertas de la Academy están abiertas.",
        "Entra, viajero.",
        "Tu viaje hacia la sabiduría práctica y la libertad interior comienza.",
      ],
    },
  },
];

export const sceneImg = (sc) => `/onboarding/${sc.id}.jpg`;
export const sceneImgMobile = (sc) => `/onboarding/${sc.id}-mobile.jpg`;
export const sceneAudio = (sc) => `/onboarding/audio/${sc.id}.mp3`;
